import {
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata
} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {
    BymoPagePropsContentSettingSpecialSemanticMeaning,
    BymoPagePropsContentSettingType,
    bymoPagePropsCreateContentSettingMetadata
} from '../../client-server-common';

export namespace DoppeActionTypeFBMessengerButton {

    export interface ActionSettings {
        userName: string;
        showContactPanel: boolean
    }
}

export const doppeActionTypeFbMessengerButton = doppeActionTypeDefineMetadata<DoppeActionTypeFBMessengerButton.ActionSettings>({
    id: 'io.bymo.action/fb-messenger-button',
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction({
        userName: '',
        showContactPanel: false,
    }),
    actionSettingsMetadata: {
        contentSettingsMetadata: {
            userName: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified)
        },
        supportsActionCtaButtons: false,
        supportsContentSections: false
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: false,
    hasNoLockInnerCTA: true,
});
